import { z } from 'zod';

export const GenerateShortAnswerFromTextResponseSchema = z.object({
  question: z.string().describe('The generated short-answer question'),
  text: z.string().describe('The original text provided in the request'),
});

export type IGenerateShortAnswerFromTextResponseDto = z.infer<
  typeof GenerateShortAnswerFromTextResponseSchema
>;
